import { Inject, Options, Prop, Vue, Watch } from "vue-property-decorator";
import { Category, ComplianceForm, PracticeView, SignatoryAtcsRequest, SignatoryRequest, SignatoryView, SolelyJointly } from "@/shared/modules/typescript-trustapi-client/models";
import ModalBox from "@/shared/components/modal-box/index.vue";
import { TrustAPI } from "@/shared/modules/trust-api";
import { EventEmitter } from "events";
import store from "@/trust-atcs-app/store";
import { orderBy } from "lodash";
import FormatDateTimeMixin from '@/shared/mixins/format-datetime';


@Options({
  props: {
    signatories: Array,
  },
  components: {
    ModalBox
  },
  mixins: [
    FormatDateTimeMixin
  ]
})
export default class ViewSignatoryModal extends Vue {
  private signatories!: any[];

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  private headerText = '';
  private line2Text = '';

  private sortMethod = 'desc';
  private activeSortHeader = 0;

  private signatoriesDisplay: any = [];

  private tableHeadings = [
    { text: 'LawID', value: 'lawId', sortable: true, sortMethod: 'desc' },
    { text: 'Name', value: 'name', sortable: true, sortMethod: 'acs' },
    { text: 'Position', value: 'categoryName', sortable: true, sortMethod: 'acs' },
    { text: 'Solely/ jointly', value: 'solelyJointlyName', sortable: true, sortMethod: 'acs' },
    { text: 'Commenced', value: 'commencedDate', sortable: true, sortMethod: 'asc' },
    { text: 'Terminated', value: 'terminatedDate', sortable: true, sortMethod: 'acs' },
  ];




  created(): void {
    this.headerText = `Authorised Signatories ${this.complianceFormB.complianceYear.name}`;
    this.signatories.forEach((signatory) => {
      this.signatoriesDisplay.push({
        lawId: signatory.lawId,
        name: signatory.firstName + ' ' + signatory.lastName,
        categoryName: signatory.category?.name,
        solelyJointlyName: signatory.solelyJointly.name,
        commencedDate: signatory.commencedDate,
        terminatedDate: signatory.terminatedDate,
      });
    });

    this.sortTableColumn(0, true);
  }

  private cancelClicked() {
    this.closeModal();
  }

  private closeModal(): void {
    this.$emit('closeModal');
  }

  private sortTableColumn(index: number, sortable: boolean): void {
    if (sortable) {
      if (this.tableHeadings[index].sortable) {
        this.activeSortHeader = index;
        this.sortMethod = this.sortMethod === 'desc' ? 'asc' : 'desc';
        this.tableHeadings[index].sortMethod = this.sortMethod;
        if (this.signatoriesDisplay.length > 0) {
          const nameSorter = index == 1 ? (c: any) => c.name.toLowerCase() : [this.tableHeadings[index].value, (c: any) => c.name.toLowerCase()];
          const orderByResults = orderBy(
            this.signatoriesDisplay,
            nameSorter,
            [this.sortMethod as any]
          );
          this.signatoriesDisplay = orderByResults;
        }
      }
    }
  }

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  get complianceFormB(): ComplianceForm {
    return store.getters.getSelectedComplianceFormB;
  }


}

